import React from "react";
import { useFormContext } from "react-hook-form";
import { AccessLevelSelect, PayGroupSelect, LocationsSelect } from ".";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { CreateAdminFormFields } from "Shared/types/Admins";
import { FieldsGroup } from "Components/Shared/FormComponents/FieldsGroup/FieldsGroup";

const CreateAdminFormSelects = () => {
  const { companies } = usePartnerConfig();
  const shouldSkipPaygroupSelection = companies.length < 2;
  const { setValue } = useFormContext<CreateAdminFormFields>();

  if (shouldSkipPaygroupSelection) {
    const [company] = companies;
    setValue("companyIds", [{ label: company.payGroup, value: company.id }]);
  }

  return (
    <FieldsGroup>
      <AccessLevelSelect />
      {!shouldSkipPaygroupSelection && <PayGroupSelect />}
      <LocationsSelect />
    </FieldsGroup>
  );
};

export default CreateAdminFormSelects;
